var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.5h6a3 3 0 0 0 0-6h-3a3 3 0 0 1 0-6h4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.5h4l-1.2 2 1.2 2h-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestones);
export default __webpack_public_path__ + "static/media/milestones.c91d7841feb35416f5cf1b7dace9eced.svg";
export { ForwardRef as ReactComponent };